import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { StripeProvider } from 'react-stripe-elements';

import App from './App';
import { unregister } from './registerServiceWorker';
import './index.css';
import store from './common/store';

ReactDOM.render(
	<StripeProvider apiKey={process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY!}>
		<Provider store={store}>
			<App />
		</Provider>
	</StripeProvider>,
	document.getElementById('root') as HTMLElement
);

// service workers need more work before using in an app. (ie notification of a new version)
// registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx